export default __webpack_public_path__ + "static/media/event1.0ac5a40c.png";